import {
  selectMatchTitle,
  selectTourNameDisplayForTournamentId,
  selectTourTrigramDisplayForTournamentId,
} from "selectors/Tour";
import {
  selectTournamentName,
  selectTournamentTrigram,
} from "selectors/Tournament";
import { TournamentDetailsContainer } from "./styles";
import { useAppSelector } from "app/hooks";

interface Props {
  matchId: string;
  tournamentId: string;
  includeMatchPart: boolean;
}

export const TournamentDetails = ({
  matchId,
  tournamentId,
  includeMatchPart,
}: Props) => {
  const tournamentName = useAppSelector((state) =>
    selectTournamentName(state, tournamentId)
  );

  const tournamentTrigram = useAppSelector((state) =>
    selectTournamentTrigram(state, tournamentId)
  );

  const matchTitle = useAppSelector((state) =>
    selectMatchTitle(state, matchId, tournamentId, includeMatchPart)
  );

  const tourName = useAppSelector((state) =>
    selectTourNameDisplayForTournamentId(state, tournamentId)
  );

  const tourTrigram = useAppSelector((state) =>
    selectTourTrigramDisplayForTournamentId(state, tournamentId)
  );

  return (
    <TournamentDetailsContainer>
      {!!tourTrigram && <span title={tourName}>{tourTrigram}</span>}
      <span title={tournamentName}>{tournamentTrigram}</span>
      <span>{matchTitle}</span>
    </TournamentDetailsContainer>
  );
};
